import { gql } from "@apollo/client";
import { TypeDefinitionAttributeFields } from "../fragments/typeDefinitionAttribute";

export const ServiceReminderTdas = gql`
    query ServiceReminderTdas ($installedBaseNodeId: ID!, $typeDefinitionIndex: ServiceReminderTypeDefinitionIndex!) {
        serviceReminderList (installedBaseNodeId: $installedBaseNodeId) {
            typeDefinitionAttributeList (typeDefinitionIndex: $typeDefinitionIndex) {
                total
                typeDefinitionAttributes {
                    ...TypeDefinitionAttributeFields
                }
            }
        }
    }
    ${TypeDefinitionAttributeFields}
`;
